import React from "react";

interface ChatMessageSkeletonProps {
    rows?: number;
    compact?: boolean;
}

const widths = [68, 48, 76, 56, 64, 44];

const ChatMessageSkeleton: React.FC<ChatMessageSkeletonProps> = ({ rows = 6, compact = false }) => (
    <div className={`chat-message-skeleton flex w-full flex-col ${compact ? "gap-2.5 px-3 py-3" : "gap-4 px-5 py-5"}`} aria-label="Loading messages" aria-busy="true">
        {Array.from({ length: rows }).map((_, index) => {
            const mine = index % 3 === 1;
            return (
                <div key={index} className={`flex animate-pulse items-start gap-2.5 ${mine ? "flex-row-reverse" : ""}`}>
                    <div className="chat-skeleton-avatar h-8 w-8 shrink-0 rounded-full" />
                    <div className={`flex max-w-[78%] flex-1 flex-col ${mine ? "items-end" : "items-start"}`}>
                        <div className="chat-skeleton-line mb-1.5 h-2.5 w-24 rounded-full" />
                        <div className="chat-skeleton-bubble h-10 rounded-xl" style={{ width: `${widths[index % widths.length]}%` }} />
                    </div>
                </div>
            );
        })}
    </div>
);

export default ChatMessageSkeleton;
